import React from 'react';

interface Props {
  src: string;
}

function ThumbnailPreview({ src }: Props) {
  return (
    <div
      css={{
        height: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img src={src} css={{ maxWidth: '100%', maxHeight: '90%' }} />
    </div>
  );
}

export default ThumbnailPreview;
